/* cSpell:disable */
import React, { Component } from 'react';

class ErrorTemplateImage extends Component {
	render(): React.ReactNode {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				width="690px"
				height="479px"
				viewBox="0 0 690 479"
				version="1.1"
				data-inject-url="http://portal.finanfarma.local/media/1040/404drawing.svg"
				className="card-img-top svg"
			>
				<g id="404-Error--inject-7" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="1-IB-404-Error--inject-7" transform="translate(-615.000000, -172.000000)" fillRule="nonzero">
						<g id="undraw_not_found_60pq--inject-7" transform="translate(615.000000, 172.000000)">
							<circle id="Oval--inject-7" fill="#FF6584" cx="130.497988" cy="62.5" r="39.5"></circle>
							<path
								d="M322.997988,210.819511 C322.997988,303.603351 267.481293,336 198.997988,336 C130.514671,336 74.9979879,303.603351 74.9979879,210.819511 C74.9979879,118.035671 198.997988,0 198.997988,0 C198.997988,0 322.997988,118.035671 322.997988,210.819511 Z"
								id="Path--inject-7"
								fill="#F2F2F2"
							></path>
							<polygon
								id="Path--inject-7"
								fill="#3F3D56"
								points="194.375909 322.861077 195.63439 244.955026 247.997988 148.574003 195.831679 232.733719 196.397199 197.703951 232.48632 127.973587 196.546697 188.434103 196.546697 188.434103 197.563776 125.431437 236.209071 69.9171415 197.724302 115.524202 198.35967 0 194.364881 152.933383 194.693287 146.62424 155.402821 86.1174924 194.063434 158.735206 190.402565 229.098025 190.293505 227.230864 144.997988 163.556291 190.15626 233.828496 189.698575 242.628009 189.616474 242.760541 189.653848 243.482995 180.365963 422 192.775543 422 194.264398 329.792196 239.31116 259.691976"
							></polygon>
							<path
								d="M689.997988,249.173186 C689.997988,325.388467 644.778749,352 588.997988,352 C533.217227,352 487.997988,325.388467 487.997988,249.173186 C487.997988,172.957904 588.997988,76 588.997988,76 C588.997988,76 689.997988,172.957886 689.997988,249.173186 Z"
								id="Path--inject-7"
								fill="#F2F2F2"
							></path>
							<polygon
								id="Path--inject-7"
								fill="#3F3D56"
								points="584.747089 339.950538 585.784842 276.259802 628.997988 197.464912 585.947917 266.268145 586.414906 237.630402 616.197181 180.62273 586.538448 230.051543 586.538448 230.051543 587.377916 178.544854 619.269054 133.159741 587.509488 170.445757 588.034542 76 584.737823 201.028392 585.008998 195.870951 552.584158 146.403967 584.488886 205.772105 581.467666 263.296321 581.37748 261.769468 543.997988 209.712989 581.264439 267.163325 580.8864 274.357392 580.81907 274.465749 580.849956 275.056174 573.184791 421 583.425807 421 584.654432 345.617136 621.829462 288.307787"
							></polygon>
							<ellipse
								id="Oval--inject-7"
								fill="#3F3D56"
								cx="341.497988"
								cy="419.5"
								rx="341.5"
								ry="17.5"
							></ellipse>
							<ellipse
								id="Oval--inject-7"
								fill="#3F3D56"
								cx="549.497988"
								cy="447"
								rx="58.5"
								ry="3"
							></ellipse>
							<ellipse
								id="Oval--inject-7"
								fill="#3F3D56"
								cx="337.497988"
								cy="476"
								rx="58.5"
								ry="3"
							></ellipse>
							<ellipse
								id="Oval--inject-7"
								fill="#3F3D56"
								cx="177.497988"
								cy="452.5"
								rx="133.5"
								ry="6.5"
							></ellipse>
							<circle id="Oval--inject-7" fill="#2F2E41" cx="59.4979879" cy="348.5" r="48.5"></circle>
							<polygon
								id="Rectangle--inject-7"
								fill="#2F2E41"
								transform="translate(44.360062, 399.873413) rotate(0.675090) translate(-44.360062, -399.873413) "
								points="36.9711267 386.636275 51.7490309 386.636257 51.7489981 413.11055 36.9710939 413.110569"
							></polygon>
							<polygon
								id="Rectangle--inject-7"
								fill="#2F2E41"
								transform="translate(73.913818, 400.221612) rotate(0.675090) translate(-73.913818, -400.221612) "
								points="66.5248819 386.984474 81.302786 386.984456 81.3027532 413.458749 66.5248491 413.458767"
							></polygon>
							<ellipse
								id="Oval--inject-7"
								fill="#2F2E41"
								transform="translate(49.126069, 413.475490) rotate(-89.324910) translate(-49.126069, -413.475490) "
								cx="49.126069"
								cy="413.47549"
								rx="4.61760932"
								ry="12.3149201"
							></ellipse>
							<ellipse
								id="Oval--inject-7"
								fill="#2F2E41"
								transform="translate(78.687080, 413.208047) rotate(-89.324910) translate(-78.687080, -413.208047) "
								cx="78.68708"
								cy="413.208047"
								rx="4.61760932"
								ry="12.3149201"
							></ellipse>

							<circle id="first-eye--inject-7" fill="#ffffff" cx="60.9979879" cy="336" r="17"></circle>
							<circle id="Oval--inject-7" fill="#3F3D56" cx="60.9979879" cy="336" r="6"></circle>
							<rect x="42.99" y="318" width="34" height="0" fill="#2F2E41" id="fillup--inject-7"></rect>

							<path
								d="M12.644538,303.404869 C8.91253893,285.692087 21.7169304,267.989615 41.2439544,263.865291 C60.7709784,259.740968 79.6261456,270.756595 83.358157,288.469377 C87.0901684,306.182159 74.1061645,312.545514 54.5791467,316.669849 C35.0521289,320.794185 16.3765432,321.117657 12.644538,303.404869 Z"
								id="Path--inject-7"
								fill="#00C189"
							></path>
							<path
								d="M134.997988,375.547415 C134.997988,409.236883 114.851767,421 89.9979879,421 C89.4222314,421 88.8473887,420.993638 88.2734629,420.980915 C87.1219171,420.95638 85.981349,420.901885 84.854503,420.825545 C62.4244383,419.247508 44.9979879,406.879348 44.9979879,375.547396 C44.9979879,343.122552 86.6805011,302.207873 89.8115361,299.179868 L89.8170249,299.17443 C89.9376813,299.057236 89.9979879,299 89.9979879,299 C89.9979879,299 134.997988,341.857952 134.997988,375.547415 Z"
								id="Path--inject-7"
								fill="#00C189"
							></path>
							<path
								d="M88.2151407,415.864412 L104.791936,392.999644 L88.1737034,418.374964 L88.1295453,421 C86.9697274,420.975461 85.8209661,420.920957 84.6860254,420.844606 L86.47269,387.133501 L86.4588693,386.871809 L86.4892377,386.822743 L86.657683,383.638906 L69.9979879,358.200878 L86.7101335,381.251024 L86.7488315,381.92705 L88.0991335,356.456327 L73.8364083,330.170538 L88.2731072,351.985863 L89.678661,299.179866 L89.6841893,299 L89.6841893,299.174458 L89.4494789,340.815205 L103.648734,324.307197 L89.3914939,344.402468 L89.0159487,367.207274 L102.273561,345.321068 L88.9607464,370.562834 L88.7508761,383.24092 L107.997988,352.779077 L88.6790766,387.665072 L88.2151407,415.864412 Z"
								id="Path--inject-7"
								fill="#3F3D56"
							></path>
							<circle id="Oval--inject-7" fill="#2F2E41" cx="438.497988" cy="348.5" r="48.5"></circle>
							<polygon
								id="Rectangle--inject-7"
								fill="#2F2E41"
								transform="translate(439.651577, 401.597446) rotate(-17.083450) translate(-439.651577, -401.597446) "
								points="432.262301 388.359961 447.040071 388.360397 447.040853 414.834931 432.263083 414.834494"
							></polygon>
							<polygon
								id="Rectangle--inject-7"
								fill="#2F2E41"
								transform="translate(467.902527, 392.918899) rotate(-17.083183) translate(-467.902527, -392.918899) "
								points="460.513245 379.681404 475.291027 379.68184 475.291809 406.156394 460.514028 406.155957"
							></polygon>
							<ellipse
								id="Oval--inject-7"
								fill="#2F2E41"
								transform="translate(448.339652, 413.097878) rotate(-17.083450) translate(-448.339652, -413.097878) "
								cx="448.339652"
								cy="413.097878"
								rx="12.3148085"
								ry="4.61765118"
							></ellipse>
							<ellipse
								id="Oval--inject-7"
								fill="#2F2E41"
								transform="translate(476.410507, 403.827839) rotate(-17.083450) translate(-476.410507, -403.827839) "
								cx="476.410507"
								cy="403.827839"
								rx="12.3148085"
								ry="4.61765118"
							></ellipse>
							<circle id="second-eye--inject-7" fill="#FFFFFF" cx="435.997988" cy="336" r="17"></circle>
							<circle id="Oval--inject-7" fill="#3F3D56" cx="435.997988" cy="335" r="6"></circle>
							<rect
								x="418.99"
								y="319"
								width="34"
								height="0"
								fill="#2F2E41"
								id="fillup-two--inject-7"
							></rect>
							<path
								d="M380.883975,319.376483 C372.063191,303.702319 378.766431,283.005701 395.856084,273.149303 C412.945737,263.292905 433.950292,268.009133 442.771076,283.683296 C451.59186,299.35746 441.315682,309.347636 424.226029,319.20404 C407.136376,329.060444 389.704759,335.050647 380.883975,319.376483 Z"
								id="Path--inject-7"
								fill="#00C189"
							></path>
							<path
								d="M351.997988,369.900465 C351.997988,401.104649 333.4187,412 310.497988,412 C309.967016,412 309.436884,411.994108 308.907595,411.982323 C307.845614,411.959598 306.793753,411.909122 305.754553,411.838434 C285.069046,410.376808 268.997988,398.921052 268.997988,369.900477 C268.997988,339.867622 307.438533,301.971233 310.326038,299.166609 L310.331101,299.161566 C310.442377,299.053018 310.498016,299 310.498016,299 C310.498016,299 351.997988,338.696281 351.997988,369.900465 Z"
								id="Path--inject-7"
								fill="#00C189"
							></path>
							<path
								d="M308.776953,407.243272 L324.045082,386.065256 L308.738789,409.568616 L308.69812,412 C307.629865,411.977271 306.57179,411.926788 305.526451,411.856088 L307.172068,380.631877 L307.159338,380.389487 L307.187322,380.344047 L307.342468,377.395079 L291.997988,353.83363 L307.39078,375.183349 L307.426419,375.809499 L308.67013,352.217771 L295.533386,327.871095 L308.830351,348.077087 L310.124943,299.166635 L310.130036,299 L310.130036,299.161591 L309.913854,337.730457 L322.9921,322.440266 L309.860418,341.053091 L309.514517,362.175569 L321.725485,341.903951 L309.463661,365.283622 L309.270358,377.026456 L326.997988,348.811808 L309.204211,381.124219 L308.776953,407.243272 Z"
								id="Path--inject-7"
								fill="#3F3D56"
							></path>
							<path
								d="M513.997988,382.547415 C513.997988,416.236883 493.851767,428 468.997988,428 C468.422236,428 467.847393,427.993638 467.273463,427.980915 C466.121917,427.95638 464.981349,427.901885 463.854503,427.825545 C441.424438,426.247508 423.997988,413.879348 423.997988,382.547396 C423.997988,350.122552 465.680501,309.207873 468.811536,306.179868 L468.817025,306.17443 C468.937681,306.057236 468.997988,306 468.997988,306 C468.997988,306 513.997988,348.857952 513.997988,382.547415 Z"
								id="Path--inject-7"
								fill="#00C189"
							></path>
							<path
								d="M467.215118,422.864411 L483.791933,399.99964 L467.173681,425.374964 L467.129523,428 C465.969703,427.975461 464.820941,427.920957 463.685999,427.844606 L465.472665,394.133496 L465.458845,393.871804 L465.489213,393.822738 L465.657659,390.638901 L448.997988,365.200887 L465.710153,388.251036 L465.748851,388.927062 L467.099154,363.456336 L452.836413,337.170543 L467.273128,358.985871 L468.678683,306.179866 L468.684212,306 L468.684212,306.174458 L468.449501,347.815211 L482.648773,331.307201 L468.391516,351.402474 L468.015939,374.207284 L481.273555,352.321056 L467.960725,377.562827 L467.750854,390.240914 L486.997988,359.779067 L467.679055,394.665067 L467.215118,422.864411 Z"
								id="Path--inject-7"
								fill="#3F3D56"
							></path>
							<ellipse
								id="Oval--inject-7"
								fill="#2F2E41"
								transform="translate(419.787461, 366.810595) rotate(-64.625740) translate(-419.787461, -366.810595) "
								cx="419.787461"
								cy="366.810595"
								rx="7.63476105"
								ry="24.3214977"
							></ellipse>
							<ellipse
								id="Oval--inject-7"
								fill="#2F2E41"
								transform="translate(44.798143, 363.732169) rotate(-68.158290) translate(-44.798143, -363.732169) "
								cx="44.7981433"
								cy="363.732169"
								rx="7.63472472"
								ry="24.3216134"
							></ellipse>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}
export default ErrorTemplateImage;
